export default {
    increment(state) {
      state.counter++
    },

    // 用来修改分页信息
    CHANGE_PAGIN_INFO(state,info){

      // tagTotal:1         //存储每个标签的总数
      // curren_page:val,   //存储当前页的页数
      

      //判断两个数值是不是一模一样 是的话只需要执行一次(只有分页会这样分页造成)
      console.log('mutation:',info.curren_page!=state.pagin_info.curren_page)
      if(info.curren_page!=state.pagin_info.curren_page){
        const res = Object.assign( state.pagin_info,info)
          state.pagin_info = res
          console.log('修改分页信息：',info)
      }
      
    },
    
    // 用来存储获取到值，暂时放在这里
    SAVE_DATA(state,info){
      state.indexData=info
    },

    SET_IMAGE_LIKE(state, info) {
      console.log('image like tem', info)
      state.temImageLike = info
    },
    SET_TEMLOGIN(state,info) {
      console.log('temp', info)
      state.temLogin = info
    }
  }